import React, {Component} from 'react'
import classNames from 'classnames'
import videoEdit from "../../../icon/video-name-edit.svg";
import InlineSVG from "react-inlinesvg";
import './FJInput.less'

class FJInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      isMouseIn: false,
    };
  }

  componentDidMount() {
    this.input.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  }

  /**
   * @description 返回选中的长度
   * @param myField
   * @return {number}
   */
  _getSelectionLength = (myField) => {
    return myField.selectionEnd - myField.selectionStart;
  };

  /**
   * @description 在光标处插入
   * @param myField
   * @param myValue
   * @return {string}
   */
  _insertAtCursor = (myField, myValue) => {
    // IE support
    if (document.selection) {
      myField.focus();
      let sel = document.selection.createRange();
      sel.text = myValue;
    }
    // MOZILLA and others
    else if (myField.selectionStart || Number(myField.selectionStart) === 0) {
      let startPos = myField.selectionStart;
      let endPos = myField.selectionEnd;
      myField.value = myField.value.substring(0, startPos)
        + myValue
        + myField.value.substring(endPos, myField.value.length);
    } else {
      myField.value += myValue;
    }

    return myField.value;
  };

  onPaste = (e) => {
    let curValueLength = e.target.value.length;
    let pasteValue = e.clipboardData.getData("text");
    let pasteValueLength = pasteValue.length;
    let value = pasteValue;
    let maxLength = this.props.maxLength || 50;
    if (pasteValueLength - this._getSelectionLength(this.input) + curValueLength > maxLength) {
      value = pasteValue.slice(0, maxLength - pasteValueLength - curValueLength);
      this._insertAtCursor(this.input, value);
      e.preventDefault();
    }
    this.onChange(e);
  };
  onMouseEnter = () => {
    this.setState({isMouseIn: true});
  };
  onMouseLeave = () => {
    this.setState({isMouseIn: false});
  };
  onFocus = (e) => {
    let value = this.input.value;
    this.input.value = '';
    this.input.value = value;
    this.setState({isFocused: true}, () => {
      this.input.select()
    });
    this.props.onFocus && this.props.onFocus();
  };
  onBlur = (e) => {
    let {onSubmit} = this.props;
    let value = e.target.value;
    this.setState({isFocused: false}, () => {
      if (onSubmit) {
        onSubmit(value);
      }
    });
  };
  onChange = (e) => {
    let maxLength = this.props.maxLength || 50;
    let {onChange} = this.props;
    if (e.target.value.length > maxLength) {
      return;
    }
    if (onChange) {
      onChange(e.target.value);
    }
  };
  onKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.input.blur();
    }
  };
  errorAnimation = () => {
    if (this.error) {
      window.requestAnimationFrame(() => {
        this.error.classList.remove('animation-shake');
        window.requestAnimationFrame(() => {
          this.error.classList.add('animation-shake');
        });
      });
    }
  };
  isInputNone = () => {
    return this.props.value.trim() === '';
  };
  getValue = () => {
    return this.props.value;
  };

  render() {
    let {isFocused, isMouseIn} = this.state;
    let {placeholder, hasError, errorValue, value, hasIcon = false} = this.props;
    let containerClass = classNames('c-input-container', {active: isFocused || isMouseIn}, this.props.className);
    return (
      <div className={containerClass} style={this.props.style}>
        <input value={value}
               placeholder={placeholder}
               ref={ele => this.input = ele}
               onFocus={this.onFocus}
               onBlur={this.onBlur}
               onKeyDown={this.onKeyDown}
               onChange={this.onChange}
               onPaste={this.onPaste}
               onMouseEnter={this.onMouseEnter}
               onMouseLeave={this.onMouseLeave}/>
        {
          hasError && value.trim() === '' ?
            <p ref={ele => this.error = ele} className='c-input-tip animation-shake'>{errorValue}</p> : null
        }
        {
          hasIcon && isFocused ? <InlineSVG src={videoEdit} element='div' className='c-input-edit'/> : null
        }

      </div>
    );
  }
}


export default FJInput;
